import { Formik } from "formik";
import { useQuery } from "react-query";
import { PrimarySubmitButton } from "src/reusable/Buttons";
import Card from "src/reusable/Card";
import { Input } from "src/reusable/Form";
import FormikTextarea from "src/reusable/Form/input/Textarea";
import Loader from "src/components/Dashboard/common/Loader";
import { getDocgTaxSettings, updateDocgTaxSettings } from "./api";

const TaxSettingsCard = () => {
  const { data, isLoading, refetch } = useQuery("docgTaxSettings", getDocgTaxSettings);

  if (isLoading) {
    return <Loader />;
  }

  const initial = {
    sacCode: data?.sacCode ?? "998314",
    gstRatePercent: data?.gstRatePercent ?? 18,
    invoiceServiceDescription: data?.invoiceServiceDescription ?? "DocG Cloud EMR Subscription",
    supplierLegalName: data?.supplierLegalName ?? "",
    supplierGstin: data?.supplierGstin ?? "",
    supplierAddress: data?.supplierAddress ?? "",
    supplierState: data?.supplierState ?? "Delhi",
  };

  return (
    <Card title="GST tax settings (subscription invoices)">
      <p style={{ marginBottom: "1rem" }}>
        Platform GST settings for <strong>DocG-issued</strong> subscription tax invoices (not clinic GSTIN).
        SAC and GST % are snapshotted on each invoice. Razorpay plan prices must remain GST-inclusive.
      </p>
      <Formik
        enableReinitialize
        initialValues={initial}
        onSubmit={async (values, { setSubmitting }) => {
          try {
            await updateDocgTaxSettings(values);
            refetch();
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {({ handleSubmit, isSubmitting, values, setFieldValue }) => (
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-4">
                <Input label="SAC code" name="sacCode" value={values.sacCode} onChange={(e) => setFieldValue("sacCode", e.target.value)} />
              </div>
              <div className="col-md-4">
                <Input
                  label="GST rate (%)"
                  name="gstRatePercent"
                  type="number"
                  value={values.gstRatePercent}
                  onChange={(e) => setFieldValue("gstRatePercent", e.target.value)}
                />
              </div>
              <div className="col-md-4">
                <Input
                  label="Supplier state (place of supply for DocG)"
                  name="supplierState"
                  value={values.supplierState}
                  onChange={(e) => setFieldValue("supplierState", e.target.value)}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Input
                  label="Supplier legal name"
                  name="supplierLegalName"
                  value={values.supplierLegalName}
                  onChange={(e) => setFieldValue("supplierLegalName", e.target.value)}
                />
              </div>
              <div className="col-md-6">
                <Input
                  label="DocG supplier GSTIN (issuer)"
                  name="supplierGstin"
                  value={values.supplierGstin}
                  onChange={(e) => setFieldValue("supplierGstin", e.target.value)}
                />
              </div>
            </div>
            <FormikTextarea
              label="Supplier address"
              name="supplierAddress"
              value={values.supplierAddress}
              onChange={(e) => setFieldValue("supplierAddress", e.target.value)}
            />
            <FormikTextarea
              label="Service description on invoice"
              name="invoiceServiceDescription"
              value={values.invoiceServiceDescription}
              onChange={(e) => setFieldValue("invoiceServiceDescription", e.target.value)}
            />
            <PrimarySubmitButton label={isSubmitting ? "Saving…" : "Save tax settings"} disabled={isSubmitting} />
          </form>
        )}
      </Formik>
    </Card>
  );
};

export default TaxSettingsCard;
